module.exports = __webpack_public_path__ + "img/iphonemockup4.153c8ef3.svg";